import React, { useState, useMemo, useCallback } from 'react';

import { subDays, format } from 'date-fns';

import { Report } from '~/components';
import { DateTime, Autocomplete, RadioGroup, Select } from '~/components/Form';
import { t } from '~/helpers';

export default function RelDesempenhoModeloVeiculo() {
  const [open, setOpen] = useState(true);
  const [name, setName] = useState('');

  const dateTime = useMemo(
    () => ({
      start: format(subDays(new Date(), 7), 'dd/MM/yyyy 00:00:00'),
      end: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );

  const exports = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'excel' },
    ],
    []
  );

  const options = useMemo(
    () => [
      { label: t('s.relatorio.geral.analiseanalitico'), value: 'A' },
      { label: t('s.relatorio.geral.analisesintetico'), value: 'S' },
    ],
    []
  );

  const handleSerializeFormData = useCallback(
    (data) => ({ ...data, nomemodeloveiculo: name }),
    [name]
  );

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.relatorio.reldesempenhomodeloveiculo')}
      relatorio="reldesempenhomodeloveiculo"
      serialize={handleSerializeFormData}
      initials={{
        datahorainicial: dateTime.start,
        datahorafinal: dateTime.end,
        formato: 'pdf',
        tipo: 'A',
      }}
    >
      <DateTime
        time
        name="datahorainicial"
        label={t('s.geral.opcoes.datahorainicial')}
      />

      <DateTime
        time
        name="datahorafinal"
        label={t('s.geral.opcoes.datahorafinal')}
      />

      <Autocomplete
        name="idmodeloveiculo"
        title={t('s.cadastro.veiculo.idmodeloveiculo')}
        label="nomemodelomarcamodeloveiculo"
        unique="idmodeloveiculo"
        url="modelosveiculos"
        getValue={(value) => setName(value.nomemodelomarcamodeloveiculo || '')}
        params={{
          fieldlist: 'idmodeloveiculo,nomemodelomarcamodeloveiculo',
          orderfield: 'nomemodelomarcamodeloveiculo',
        }}
      />

      <Select
        name="tipo"
        label={t('s.configuracao.produto.tipoproduto')}
        options={options}
      />

      <RadioGroup
        row
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={exports}
        serialize={(value) => value}
      />
    </Report>
  );
}
